import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

const css = {
  paging: (i, activeIndex, color) => ({
    width: activeIndex === i ? 24 : 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: color,
    transition: 'all 0.3s ease',
    mx: 0.2,
  }),
};

const CustomPaging = ({ i, activeIndex, color }) => <Box sx={css.paging(i, activeIndex, color)} />;

CustomPaging.propTypes = {
  color: PropTypes.string.isRequired,
  i: PropTypes.number.isRequired,
  activeIndex: PropTypes.number.isRequired,
};

export default CustomPaging;
